// extracted by mini-css-extract-plugin
export default {"select":"ComboboxInput_select__h2OeC"};